module.exports = __webpack_public_path__ + "static/media/hack.e5061fe6.jpg";